import '../App.scss';
import React, { useState, Component } from 'react';
import TextBox from '../components/Atoms/TextBox'
import TopBarAlt from '../components/Organisms/TopBarAlt'
import Heading from '../components/Atoms/Heading'
import List from '../components/Molecules/List'
import FilterSection from '../components/Molecules/FilterSection'
import Divider from '../components/Atoms/Divider'
import { client } from '../client';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
  useParams
} from "react-router-dom";



class Filter extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      category: ''
      
    }  
  }

  //this is where we receive API calls inside components
  componentDidMount() {

    // if (this.props.match.path) {
    //   let path = this.props.match.path;
    //   let category = '';

    //   if (path == "/filter/nyheder") {
    //     category = "news"
    //   }
    //   else if (path == "/filter/vaerker") {
    //     category = "workItem"
    //   }
    //   else if (path == "/filter/kuratering") {
    //     category = "curationItem"
    //   }

    //   this.setState({
    //     currentCategory : category
        
    //   })  

    

    client.getEntries({
      // content_type: category
    })
      .then((response) => {
        this.setState({
          data : response.items
          // category: category
          
        })  
    })
      // .then((data) => {
      //   console.log(this.state.cardData)
      //   getEntries({'metadata.tags.sys.id[all]': 'tagOne,tagTwo'}))
      
      //   })

    
    .catch(console.error)

  // }
  }




  render() {
    
  // console.log(this.state.category)
  
  const {data, category} = this.state;

  return (
    <div className="news-page h-101" >
      <TopBarAlt />
      <Heading cx="bb pa-m" content={`FILTRER INDHOLD`} headingLevel="h2"/>
      
      {/* <List listData={data} category="workItem"/> */}
      {/* <List listData={data} category={category}/> */}
      <Switch>
        
        <Route path="/filter/vaerker">
          <FilterSection category="VÆRKER OG UDSTILLINGER"/>
          <List  category="workItem"/>
          
        </Route>
        <Route path={"/filter/nyheder"}>
          <FilterSection category="NYHEDER"/>
          <List category="news"/>
          
        </Route>
        <Route path={"/filter/kuratering"}>
          <FilterSection category="KURATERING"/>
          <List category="curationItem"/>
          
        </Route>
      </Switch>


      


    </div>

  );
};
}

export default Filter;



